import { LauncherElement } from '../../types/launcherElement';

export const recursivelyRandomizeIDs = (element: LauncherElement) => {
  element.id = crypto.randomUUID();

  element?.props?.children?.forEach((child) => {
    recursivelyRandomizeIDs(child);
  });

  return element;
};
